<template>
  <div class="pay-succ">
    <img src="@/assets/images_member/icon-ding2 (8).png" class="img" alt="">
    <div class="pay-txt1">{{ menberOrder.order_info.card_info.pay_sussess_msg }}</div>
    <div class="zhanggui-div">
      <div class="txt1">
        <span class="txt1-span">
          升级账号：
        </span>
        {{ userInfo.mobile }}
      </div>
      <div class="txt1">
        <span class="txt1-span" >
          有效期：{{ menberOrder.order_info.end_time }}
        </span>
      </div>
      <img :src="menberOrder.service_qr_code" class="img-code" alt="">
      <div class="txt2">长按图片保存，打开微信扫码添加企业客服为您服务</div>
    </div>
    <div class="btn-txt" @click="handleJump">返回首页</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      menberOrder: {},
    }
  },
  computed: {
    userInfo () {
      return JSON.parse(this.$ls.storage['xingfugongshe_user-info']).value
    },
  },
  created () {
    this.menberOrder = JSON.parse(localStorage.getItem('menberOrder'))
  },
  methods: {
    handleJump () {
      this.$router.push({
        path: '/'
      })
    }
  },
}
</script>

<style lang="less" scoped>
.pay-succ {
  background-color: #1E2020;
  padding: 30px 14px;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;

  .img {
    width: 146px;
    display: block;
    margin-left: 50%;
    transform: translateX(-50%);
    margin-top: 20px;
  }

  .pay-txt1 {
    font-size: 20px;
    color: #F0E1C0;
    font-weight: bold;
    line-height: 20px;
    margin-top: 24px;
    text-align: center;
  }

  .zhanggui-div {
    background-color: #2F3131;
    border-radius: 10px;
    overflow: hidden;
    padding: 22px 14px;
    box-sizing: border-box;
    margin-top: 30px;

    .txt1 {
      font-size: 12px;
      color: #FFFFFF;
      line-height: 18px;
      display: flex;
      margin-bottom: 14px;

      .txt1-span {
        min-width: 68px;
        display: block;
      }
    }

    .img-code {
      width: 148px;
      height: 148px;
      display: block;
      margin-left: 50%;
      transform: translateX(-50%);
      margin-top: 40px;
      border: 6px solid #585E5E;
      border-radius: 10px;
      margin-bottom: 20px;
    }

    .txt2 {
      width: 182px;
      line-height: 20px;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      margin-left: 50%;
      transform: translateX(-50%);
    }
  }

  .btn-txt {
    width: 347px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    height: 48px;
    display: block;
    border-radius: 100px;
    font-size: 18px;
    font-weight: 600;
    background-color: #F0E1C0;
    color: #504632;
    position: fixed;
    bottom: 14px;
    left: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/paySuccess.vue